<!--
  ~ VNCtalk - an enterprise real-time communication solution including chat, video and audio conferencing, screen sharing, voice messaging, file sharing, broadcasts, document collaboration and much more.
  ~ Copyright (C) 2015-2020 VNC – Virtual Network Consult AG (info@vnc.biz)
  ~
  ~ This program is free software: you can redistribute it and/or modify
  ~ it under the terms of the GNU Affero General Public License as published by
  ~ the Free Software Foundation, version 3 of the License.
  ~
  ~ This program is distributed in the hope that it will be useful,
  ~ but WITHOUT ANY WARRANTY; without even the implied warranty of
  ~ MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
  ~ GNU Affero General Public License for more details.
  ~
  ~ You should have received a copy of the GNU Affero General Public License
  ~ along with this program. Look for COPYING file in the top folder.
  ~ If not, see http://www.gnu.org/licenses/.
  -->
<vnc-dialog  [headerTemplate]="headerTemplate"
    [classes]="['create-new-ticket-dialog']" [footerTemplate]="footerTemplate" [bodyTemplate]="bodyTemplate">
</vnc-dialog>
<div #chatDragDropShade class="chat-shade-drag-n-drop">
    <div>
      <svg width="64" height="64" viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg">
          <g stroke="#388EDA" stroke-width="2" fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round">
              <path d="M29.205 24.606a3.802 3.802 0 0 1-3.803 3.803 3.802 3.802 0 0 1-3.803-3.803 3.802 3.802 0 0 1 3.803-3.803 3.802 3.802 0 0 1 3.803 3.803h0z"/>
              <path d="M14 45.523h36V17H14z"/>
              <path d="m14 45.523 9.53-13.31 6.352 5.704 8.47-13.31L50 45.522"/>
          </g>
      </svg>
      <div class="chat-shade-drag-n-drop-container">{{ 'DROP_FILES_TO_SEND_THEM' | translate }}</div>
    </div>
</div>
<ng-template #headerTemplate>
    {{ 'NEW_TICKET' | translate }}
    <span></span>
    <div class="close-btn">
        <vnc-icon-container (click)="close()">
            <mat-icon class="mdi-24px" fontSet="mdi" fontIcon="mdi-close"></mat-icon>
        </vnc-icon-container>
    </div>
</ng-template>
<ng-template #bodyTemplate>
    <div class="new-ticket-form" >
        <div class="inline">
            <div class="w-50 pr-8">
                <vnc-input [form]="ticketTitle" [showLabel]="true" placeholder="{{ 'TITLE'| translate}}" required="true"
                [class.required-field-error]="hitCreateButton && ticketTitle.value === ''"
                >
                </vnc-input>
            </div>
            <div class="pr-8" [ngClass]="{'w-50': isMobileScreen ,'w-25': !isMobileScreen}">
                <vnc-input  type="text"  placeholder="{{ 'ESTIMATE'| translate}}" [form]="ticketEstimate"
                [showLabel]="true" [label]="'label'"  [iconActionTemplate]="trailIconTemplate"
                [class.required-field-error]="hitCreateButton && ticketEstimate.value === ''"
                ></vnc-input>
                <ng-template #trailIconTemplate>
                    <span class="font-14">{{ 'HRS'| translate}}</span>
                </ng-template>

            </div>
            <div class="relative" [ngClass]="{'w-35': isMobileScreen ,'w-25': !isMobileScreen}">
                <!-- <div class="select-section">
                    <vnc-dropdown [hideDropdownIcon]="true" [control]="ticketDone"  placeholder="{{ 'DONE'| translate}}"
                    required="true" label="{{ 'DONE'| translate}}" [options]="ticketDoneOptions"></vnc-dropdown>
                    <svg width="18px" height="18px" class="down-arrow-icon" viewBox="0 0 24 25" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                        <g id="Icon/product/keyboard-arrow-down-new" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                            <path d="M7.25735931,9.79289322 C7.6478836,9.40236893 8.28104858,9.40236893 8.67157288,9.79289322 L12.5,13.6213203 L16.3284271,9.79289322 C16.7189514,9.40236893 17.3521164,9.40236893 17.7426407,9.79289322 C18.133165,10.1834175 18.133165,10.8165825 17.7426407,11.2071068 L12.5,16.4497475 L7.25735931,11.2071068 C6.86683502,10.8165825 6.86683502,10.1834175 7.25735931,9.79289322 Z" id="Path" fill="#8B96A0"></path>
                        </g>
                    </svg>
                </div> -->
                <div class="custom-dropdown-select">
                    <button [matMenuTriggerFor]="ticketDoneOptionMenu" class="appt-btn done-input-block">
                        <span class="input-label">{{ 'DONE' | translate }}</span>
                        <div class="percent-symbol">%</div>
                        <ng-container *ngFor="let option of ticketDoneOptions;">
                            <span class="input-value" *ngIf="ticketDone.value[0] === option?.value">{{ option.viewValue?.split("%")[0] | translate }}</span>
                        </ng-container>
                        <span class="dropdown-trigger-Icon">
                            <ng-container [ngTemplateOutlet]="matSelectTriggerIcon"></ng-container>
                        </span>
                    </button>
                </div>
                <mat-menu #ticketDoneOptionMenu="matMenu" class="create-ticket-custom-menu ticket-done-menu-panel">
                    <button vpAutoFocus mat-menu-item *ngFor="let option of ticketDoneOptions" (click)="onChangeDropdownMenu('ticketDone',option)">
                        <span>{{ option.viewValue | translate }}</span>
                        <span class="check-icon-block" *ngIf="ticketDone.value[0] === option?.value">
                            <ng-container [ngTemplateOutlet]="checkIcon"></ng-container>
                        </span>
                    </button>
                </mat-menu>

                <mat-progress-bar mode="determinate" [value]="ticketDone.value" ></mat-progress-bar>
            </div>
        </div>

        <div class="pr-8" [ngClass]="{'w-100': isMobileScreen ,'w-50': !isMobileScreen}">
            <div class="list-el-block relative"
            [class.required-field-error]="hitCreateButton && ticketProject.value === ''"

            (click)="projectListShow = !projectListShow" type="button" cdkOverlayOrigin #trigger="cdkOverlayOrigin">
               <label [ngClass]="{'label-float':(ticketProject.value!=='' || projectListShow)}">{{ 'PROJECT_LBL_NEW'| translate}}
                <span class="require">*</span>
              </label>
               <label class="selected-value-text" *ngIf="ticketProject.value">{{ ticketProject.value }}</label>
               <!-- <mat-icon class="down-arrow-icon">keyboard_arrow_down</mat-icon> -->
               <svg width="18px" height="18px" class="down-arrow-icon" viewBox="0 0 24 25" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                <g id="Icon/product/keyboard-arrow-down-new" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                    <path d="M7.25735931,9.79289322 C7.6478836,9.40236893 8.28104858,9.40236893 8.67157288,9.79289322 L12.5,13.6213203 L16.3284271,9.79289322 C16.7189514,9.40236893 17.3521164,9.40236893 17.7426407,9.79289322 C18.133165,10.1834175 18.133165,10.8165825 17.7426407,11.2071068 L12.5,16.4497475 L7.25735931,11.2071068 C6.86683502,10.8165825 6.86683502,10.1834175 7.25735931,9.79289322 Z" id="Path" fill="#8B96A0"></path>
                </g>
            </svg>
            </div>
              <div *ngIf="projectListShow" class="search-list-overlay" #projectListOverlay>
                    <ng-template
                        cdkConnectedOverlay
                        [cdkConnectedOverlayOrigin]="trigger"
                        [cdkConnectedOverlayOpen]="projectListShow"
                        [cdkConnectedOverlayHasBackdrop]="true"
                        (backdropClick)="projectListShow=false"
                        >
                        <div class="search-list-container" [style.width.px]="projectListOverlay.offsetWidth">
                            <vnc-input class="menu-project-menu" [showLabel]="true" [form]="ticketProjectSearchText" >
                            </vnc-input>
                            <div class="list-item-block">
                                <ng-container *ngFor="let item of projectList">
                                    <div class="ticket-custom-menu" (click)="selectProject(item)">
                                        <span>{{item.name}}</span>
                                        <span class="check-icon-block" *ngIf="ticketProject.value === item?.name">
                                            <ng-container [ngTemplateOutlet]="checkIcon"></ng-container>
                                        </span>
                                    </div>
                                </ng-container>
                            </div>
                        </div>
                    </ng-template>
              </div>

        </div>

        <div class="chips-section">
            <vnc-chips (clickEvent)="filterConversations('description')"    text="{{ 'DESCRIPTION' | translate}}"
                [active]="currentFilter === 'description'"  type="static"   size="s"></vnc-chips>
            <vnc-chips (clickEvent)="filterConversations('use story')"      text="{{ 'USER_STORY' | translate}}"
                [active]="currentFilter === 'use story'"    type="static"   size="s"></vnc-chips>
            <vnc-chips (clickEvent)="filterConversations('tech specs')"     text="{{ 'TECH_SPECS' | translate}}"
                [active]="currentFilter === 'tech specs'"   type="static"   size="s"></vnc-chips>
            <vnc-chips (clickEvent)="filterConversations('mockups')"        text="{{ 'MOCKUPS' | translate}}"
                [active]="currentFilter === 'mockups'"      type="static"   size="s"></vnc-chips>
        </div>

        <div class="text-editor">
            <quill-editor [(ngModel)]="ticketDescriptionContent"    *ngIf="currentFilter === 'description'" placeholder="{{ 'INSERT_TEXT' | translate}}">
                <div quill-editor-toolbar>
                    <ng-container *ngTemplateOutlet="quillToolbar"></ng-container>
                </div>
            </quill-editor>
            <quill-editor [(ngModel)]="ticketUserStoryContent"      *ngIf="currentFilter === 'use story'">
                <div quill-editor-toolbar>
                    <ng-container *ngTemplateOutlet="quillToolbar"></ng-container>
                </div>
            </quill-editor>
            <quill-editor [(ngModel)]="ticketTechSpecsContent"      *ngIf="currentFilter === 'tech specs'">
                <div quill-editor-toolbar>
                    <ng-container *ngTemplateOutlet="quillToolbar"></ng-container>
                </div>
            </quill-editor>
            <quill-editor [(ngModel)]="ticketMockupsContent"        *ngIf="currentFilter === 'mockups'">
                <div quill-editor-toolbar>
                    <ng-container *ngTemplateOutlet="quillToolbar"></ng-container>
                </div>
            </quill-editor>
        </div>

        <div class="inline">
            <div class="w-50 pr-8">
                <!-- <div class="select-section">
                    <vnc-dropdown [control]="ticketStatus" [hideDropdownIcon]="true" placeholder="{{ 'STATUS'| translate}}" required="true" label="{{ 'STATUS'| translate}}" [options]="statusOptions"></vnc-dropdown>
                    <svg width="18px" height="18px" class="down-arrow-icon" viewBox="0 0 24 25" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                        <g id="Icon/product/keyboard-arrow-down-new" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                            <path d="M7.25735931,9.79289322 C7.6478836,9.40236893 8.28104858,9.40236893 8.67157288,9.79289322 L12.5,13.6213203 L16.3284271,9.79289322 C16.7189514,9.40236893 17.3521164,9.40236893 17.7426407,9.79289322 C18.133165,10.1834175 18.133165,10.8165825 17.7426407,11.2071068 L12.5,16.4497475 L7.25735931,11.2071068 C6.86683502,10.8165825 6.86683502,10.1834175 7.25735931,9.79289322 Z" id="Path" fill="#8B96A0"></path>
                        </g>
                    </svg>
                </div> -->
                <div class="custom-dropdown-select" style="margin-top: 15px;">
                    <button [matMenuTriggerFor]="ticketStatusOptionMenu" class="appt-btn">
                        <span class="input-label">{{ 'STATUS' | translate }}</span>
                        <ng-container *ngFor="let option of statusOptions;">
                            <span class="input-value" *ngIf="ticketStatus.value[0] === option?.value">{{ option.viewValue | translate }}</span>
                        </ng-container>
                        <span class="dropdown-trigger-Icon">
                            <ng-container [ngTemplateOutlet]="matSelectTriggerIcon"></ng-container>
                        </span>
                    </button>
                </div>
                <mat-menu #ticketStatusOptionMenu="matMenu" class="create-ticket-custom-menu ticket-status-menu-panel">
                    <button vpAutoFocus mat-menu-item *ngFor="let option of statusOptions" (click)="onChangeDropdownMenu('status',option)">
                        <span>{{ option.viewValue | translate }}</span>
                        <span class="check-icon-block" *ngIf="ticketStatus.value[0] === option?.value">
                            <ng-container [ngTemplateOutlet]="checkIcon"></ng-container>
                        </span>
                    </button>
                </mat-menu>
            </div>


            <div class="w-50">
                <div class="list-el-block relative pointer" (click)="assigneeListShow = !assigneeListShow" type="button" cdkOverlayOrigin #assigneeList="cdkOverlayOrigin">
                    <label [ngClass]="{'label-float':(ticketAssignee.value!=='' || assigneeListShow)}">{{ 'ASSIGNEE'| translate}}</label>
                    <label class="selected-value-text" *ngIf="ticketAssignee.value">{{ticketAssignee.value}}</label>
                    <!-- <mat-icon class="down-arrow-icon">keyboard_arrow_down</mat-icon> -->
                    <svg width="18px" height="18px" class="down-arrow-icon" viewBox="0 0 24 25" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                        <g id="Icon/product/keyboard-arrow-down-new" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                            <path d="M7.25735931,9.79289322 C7.6478836,9.40236893 8.28104858,9.40236893 8.67157288,9.79289322 L12.5,13.6213203 L16.3284271,9.79289322 C16.7189514,9.40236893 17.3521164,9.40236893 17.7426407,9.79289322 C18.133165,10.1834175 18.133165,10.8165825 17.7426407,11.2071068 L12.5,16.4497475 L7.25735931,11.2071068 C6.86683502,10.8165825 6.86683502,10.1834175 7.25735931,9.79289322 Z" id="Path" fill="#8B96A0"></path>
                        </g>
                    </svg>

                 </div>
                   <div *ngIf="assigneeListShow" class="search-list-overlay" #assigneeListOverlay>
                         <ng-template
                             cdkConnectedOverlay
                             [cdkConnectedOverlayOrigin]="assigneeList"
                             [cdkConnectedOverlayOpen]="assigneeListShow"
                             [cdkConnectedOverlayHasBackdrop]="true"
                             (backdropClick)="assigneeListShow=false"
                             >
                             <div class="search-list-container" [style.width.px]="assigneeListOverlay.offsetWidth">
                                 <vnc-input class="menu-project-menu" [showLabel]="true" [form]="ticketAssigneeSearchText" >
                                 </vnc-input>
                                 <div class="list-item-block">
                                  <div *ngFor="let assignee of assigneeOptionsList">
                                    <vp-dropdown-item itemType="drop-default" [label]="assignee.name"
                                         (click)="selectAssignee(assignee)" *ngIf="assignee.jid !== loggedInJid"
                                         ></vp-dropdown-item>
                                    <vp-dropdown-item itemType="drop-default" label="{{ 'ME_PROJECT_LBL'| translate}}"
                                        (click)="selectAssignee(assignee)" *ngIf="assignee.jid === loggedInJid"
                                    ></vp-dropdown-item>
                                  </div>
                                 </div>
                             </div>
                         </ng-template>
                   </div>

            </div>
        </div>
        <div class="inline">

            <div class="w-50 pr-8">
                <vnc-single-datepicker
                    placeholder="placeholder" [hideTime]="true"
                    [dateControl]="ticketStartDate"
                    placeholder="{{ 'START_DATE'| translate}}"
                    label="{{ 'START_DATE'| translate}}"
                ></vnc-single-datepicker>
            </div>

            <div class="w-50">
                <vnc-single-datepicker
                    placeholder="placeholder" [hideTime]="true"
                    [dateControl]="ticketDueDate"
                    placeholder="{{ 'DUE_DATE_NEW'| translate}}"
                    label="{{ 'DUE_DATE_NEW' | translate}}"
                ></vnc-single-datepicker>
            </div>
        </div>

        <div class="inline">
            <!-- <div class="w-50 pr-8">
                <vnc-dropdown [control]="ticketPriority"  placeholder="{{ 'PRIORITY'| translate}}" required="true" label="{{ 'PRIORITY'| translate}}" [options]="priorityOptions"></vnc-dropdown>
            </div> -->
            <div class="w-50 pr-8">
                <div class="list-el-block relative pointer" (click)="ticketTargetVersionShow = !ticketTargetVersionShow" cdkOverlayOrigin #targetVersion="cdkOverlayOrigin">
                    <label [ngClass]="{'label-float':(ticketTargetVersion.value!=='' || ticketTargetVersionShow)}">{{ 'TARGET_VERSION'| translate}}</label>
                    <label class="selected-value-text" *ngIf="ticketTargetVersion.value">{{ticketTargetVersion.value}}</label>
                    <!-- <mat-icon class="down-arrow-icon">keyboard_arrow_down</mat-icon> -->
                    <svg width="18px" height="18px" class="down-arrow-icon" viewBox="0 0 24 25" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                        <g id="Icon/product/keyboard-arrow-down-new" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                            <path d="M7.25735931,9.79289322 C7.6478836,9.40236893 8.28104858,9.40236893 8.67157288,9.79289322 L12.5,13.6213203 L16.3284271,9.79289322 C16.7189514,9.40236893 17.3521164,9.40236893 17.7426407,9.79289322 C18.133165,10.1834175 18.133165,10.8165825 17.7426407,11.2071068 L12.5,16.4497475 L7.25735931,11.2071068 C6.86683502,10.8165825 6.86683502,10.1834175 7.25735931,9.79289322 Z" id="Path" fill="#8B96A0"></path>
                        </g>
                    </svg>
                 </div>
                   <div *ngIf="ticketTargetVersionShow" class="search-list-overlay" #targetVersionOverlay>
                         <ng-template
                             cdkConnectedOverlay
                             [cdkConnectedOverlayOrigin]="targetVersion"
                             [cdkConnectedOverlayOpen]="ticketTargetVersionShow"
                             [cdkConnectedOverlayHasBackdrop]="true"
                             (backdropClick)="ticketTargetVersionShow=false"
                             >
                             <div class="search-list-container" [style.width.px]="targetVersionOverlay.offsetWidth">
                                 <vnc-input class="menu-project-menu" [showLabel]="true" [form]="ticketTargetVersionSearchText" >
                                 </vnc-input>
                                 <div class="list-item-block">
                                    <div *ngIf="!projectVersionList?.length" class="ticket-custom-menu">
                                        <span>No Target Version - In Progress</span>
                                    </div>
                                   <ng-container *ngFor="let item of projectVersionList" >
                                        <div class="ticket-custom-menu" (click)="selectTargetVersion(item)">
                                            <span>{{item.name}}</span>
                                            <span class="check-icon-block" *ngIf="ticketTargetVersion.value === item.name">
                                                <ng-container [ngTemplateOutlet]="checkIcon"></ng-container>
                                            </span>
                                        </div>
                                    </ng-container>
                                 </div>
                             </div>
                         </ng-template>
                   </div>
            </div>
            <div class="w-50">

                <!-- <div class="select-section">
                    <vnc-dropdown [control]="ticketType" [hideDropdownIcon]="true"
                    [class.required-field-error]="hitCreateButton && ticketType.value === ''"
                    placeholder="{{ 'TYPE'| translate}}" required="true" label="{{ 'TYPE'| translate}}" [options]="typeOptions"></vnc-dropdown>
                      <svg width="18px" height="18px" class="down-arrow-icon" viewBox="0 0 24 25" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                            <g id="Icon/product/keyboard-arrow-down-new" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                <path d="M7.25735931,9.79289322 C7.6478836,9.40236893 8.28104858,9.40236893 8.67157288,9.79289322 L12.5,13.6213203 L16.3284271,9.79289322 C16.7189514,9.40236893 17.3521164,9.40236893 17.7426407,9.79289322 C18.133165,10.1834175 18.133165,10.8165825 17.7426407,11.2071068 L12.5,16.4497475 L7.25735931,11.2071068 C6.86683502,10.8165825 6.86683502,10.1834175 7.25735931,9.79289322 Z" id="Path" fill="#8B96A0"></path>
                            </g>
                        </svg>
                </div> -->

                <div class="custom-dropdown-select">
                    <button [matMenuTriggerFor]="ticketTypeOptionMenu" class="appt-btn">
                        <span class="input-label">{{ 'TYPE' | translate }}</span>
                        <ng-container *ngFor="let option of typeOptions;">
                            <span class="input-value" *ngIf="ticketType.value[0] === option?.value">{{ option.viewValue | translate }}</span>
                        </ng-container>
                        <span class="dropdown-trigger-Icon">
                            <ng-container [ngTemplateOutlet]="matSelectTriggerIcon"></ng-container>
                        </span>
                    </button>
                </div>
                <mat-menu #ticketTypeOptionMenu="matMenu" class="create-ticket-custom-menu ticket-type-menu-panel">
                    <button vpAutoFocus mat-menu-item *ngFor="let option of typeOptions" (click)="onChangeDropdownMenu('ticketType',option)">
                        <span>{{ option.viewValue | translate }}</span>
                        <span class="check-icon-block" *ngIf="ticketType.value[0] === option?.value">
                            <ng-container [ngTemplateOutlet]="checkIcon"></ng-container>
                        </span>
                    </button>
                </mat-menu>
            </div>
        </div>

        <div class="inline">
            <div class="w-50 pr-8">
                <!-- <div class="select-section">
                <vnc-dropdown [class.required-field-error]="hitCreateButton && ticketPriority.value === ''"
                [control]="ticketPriority" [hideDropdownIcon]="true" placeholder="{{ 'PRIORITY'| translate}}" required="true" label="{{ 'PRIORITY'| translate}}" [options]="priorityOptions">
                </vnc-dropdown>
                    <svg  width="18px" height="18px" class="down-arrow-icon" viewBox="0 0 24 25" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                        <g id="Icon/product/keyboard-arrow-down-new" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                            <path d="M7.25735931,9.79289322 C7.6478836,9.40236893 8.28104858,9.40236893 8.67157288,9.79289322 L12.5,13.6213203 L16.3284271,9.79289322 C16.7189514,9.40236893 17.3521164,9.40236893 17.7426407,9.79289322 C18.133165,10.1834175 18.133165,10.8165825 17.7426407,11.2071068 L12.5,16.4497475 L7.25735931,11.2071068 C6.86683502,10.8165825 6.86683502,10.1834175 7.25735931,9.79289322 Z" id="Path" ></path>
                        </g>
                    </svg>
                </div> -->
                <div class="custom-dropdown-select">
                    <button [matMenuTriggerFor]="priorityOptionMenu" class="appt-btn">
                        <span class="input-label">{{ 'PRIORITY' | translate }}</span>
                        <ng-container *ngFor="let option of priorityOptions;">
                            <span class="input-value" *ngIf="ticketPriority.value[0] === option?.value">{{ option.viewValue | translate }}</span>
                        </ng-container>
                        <span class="dropdown-trigger-Icon">
                            <ng-container [ngTemplateOutlet]="matSelectTriggerIcon"></ng-container>
                        </span>
                    </button>
                </div>

            </div>
            <!-- <div class="w-50 pr-8">
                <vnc-dropdown [control]="ticketAnalyticsAccount"  placeholder="{{ 'ANALYTIC_ACCOUNT'| translate}}" required="true" label="{{ 'ANALYTIC_ACCOUNT'| translate}}" [options]="analyticAccountOptions"></vnc-dropdown>
            </div> -->
        </div>
        <mat-menu #priorityOptionMenu="matMenu" class="create-ticket-custom-menu priority-menu-panel">
            <button vpAutoFocus mat-menu-item *ngFor="let option of priorityOptions" (click)="onChangeDropdownMenu('priority',option)">
                <span>{{ option.viewValue | translate }}</span>
                <span class="check-icon-block" *ngIf="ticketPriority.value[0] === option?.value">
                    <ng-container [ngTemplateOutlet]="checkIcon"></ng-container>
                </span>
            </button>
        </mat-menu>
        <!-- <div class="inline">

            <div class="w-50 pr-8">
                <vnc-dropdown [control]="ticketAnalyticsAccount"  placeholder="{{ 'ANALYTIC_ACCOUNT'| translate}}" required="true" label="{{ 'ANALYTIC_ACCOUNT'| translate}}" [options]="analyticAccountOptions"></vnc-dropdown>
            </div>

            <div class="w-50">
                <vnc-input [form]="ticketStoryPoints" [showLabel]="true" placeholder="{{ 'STORY_POINTS'| translate}}" >
                </vnc-input>
            </div>
        </div> -->

        <!-- <div class="w-50 pr-8">
            <vnc-input [form]="ticketOTA" [showLabel]="true" placeholder="{{ 'OTA'| translate}}" >
            </vnc-input>

        </div> -->


        <div class="togglabe-header">
            <div class="flex-header pointer" role="button" (click)="showTags = !showTags">
                <h3>{{ 'TAGS'| translate}}<span class="count-length" *ngIf="tagsList.length">({{tagsList.length?tagsList.length:''}})</span></h3>
                <div [ngClass]="{'rotate':showTags}" class="chev-icon"><ng-container *ngTemplateOutlet="chevronDown"></ng-container></div>
            </div>

            <div class="">
                <mat-icon class="mdi-16px icon-color" fontSet="mdi" fontIcon="mdi-plus"></mat-icon>
                <mat-icon class="kebab-menu-icon icon-color ml-16 " fontSet="mdi" fontIcon="mdi-dots-vertical"></mat-icon>
            </div>

        </div>
        <div class="chips-section" *ngIf="showTags">
            <ng-container *ngFor="let tag of tagsList; index as index">
                <vnc-chips [text]="tag" type="static" size="s" matTooltip="{{ 'REMOVE' | translate }}" [removable]="true" (removeIconClick)="removeTag(index)"></vnc-chips>
            </ng-container>

            <button mat-mini-fab class="add-rounded-btn" (click)="showTagInput = !showTagInput;showTagInputData()"  matTooltip="{{ 'ADD_TAGS' | translate }}" >
                <mat-icon class="mdi-18px" fontSet="mdi" fontIcon="mdi-plus"></mat-icon>
            </button>

            <div *ngIf="showTagInput" (click)="tagsListShow = !tagsListShow;" type="button" cdkOverlayOrigin #tagsList="cdkOverlayOrigin" #tagListDiv>
                <vnc-input [form]="newTagText"
                [focused]="true"
                placeholder="{{ 'TAGS'| translate}}" (enter)="addNewTag($event)" *ngIf="showTagInput">
                </vnc-input>
                <div class="w-50">
                    <ng-template
                        cdkConnectedOverlay
                        [cdkConnectedOverlayOrigin]="tagsList"
                        [cdkConnectedOverlayOpen]="tagsListShow"
                        [cdkConnectedOverlayHasBackdrop]="true"
                        (backdropClick)="tagsListShow=false"
                        >
                        <div class="search-list-container" [style.width.px]="tagListDiv.offsetWidth">
                            <div class="list-item-block no-margin">
                              <ng-container *ngFor="let item of tagsListSuggestion" >
                                   <vp-dropdown-item itemType="drop-default" [label]="item.name"
                                   (click)="addNewTag(item.name, false)" *ngIf="notSelected(item)"></vp-dropdown-item>
                               </ng-container>
                            </div>
                        </div>
                    </ng-template>
                </div>
            </div>

        </div>

        <div class="togglabe-header">
            <div class="flex-header pointer" role="button" (click)="showWatchers = !showWatchers">
                <h3>{{'WATCHERS' |  translate}} <span class="count-length" *ngIf="watcherList.length">({{watcherList.length?watcherList.length:''}})</span> </h3>
                <div class="chev-icon" [ngClass]="{'rotate':showWatchers}" ><ng-container *ngTemplateOutlet="chevronDown"></ng-container></div>
            </div>
            <div class="">
                <mat-icon class="mdi-16px icon-color" fontSet="mdi" fontIcon="mdi-plus"></mat-icon>
                <mat-icon class="kebab-menu-icon icon-color ml-16 " fontSet="mdi" fontIcon="mdi-dots-vertical"></mat-icon>
            </div>
        </div>
        <div class="watcher-list-avatar" *ngIf="showWatchers">
            <ng-container *ngFor="let item of watcherList">
                <div class="watcher">
                    <vp-avatar [jid]="item.jid" size="conference" hidestatus="true"></vp-avatar>
                    <p>{{ item.firstname }} {{ item.lastname }}</p>
                </div>
            </ng-container>
            <button mat-mini-fab class="add-rounded-btn" (click)="addWatcher()"  matTooltip="{{ 'ADD_WATCHER' | translate }}">
                <mat-icon class="mdi-18px" fontSet="mdi" fontIcon="mdi-plus"></mat-icon>
            </button>
        </div>

        <div class="togglabe-header">
            <div class="flex-header pointer" (click)="showAttachments = !showAttachments">
                <h3>{{'ATTACHMENTS' |  translate}} <span class="count-length" *ngIf="attachmentsList.length">({{attachmentsList.length?attachmentsList.length:''}})</span></h3>
                <div class="chev-icon" [ngClass]="{'rotate':showAttachments}" ><ng-container *ngTemplateOutlet="chevronDown"></ng-container></div>
            </div>
            <div class="right-icons">
                <ng-container *ngTemplateOutlet="downLoadIcon"></ng-container>
                <mat-icon class="kebab-menu-icon icon-color ml-16 " fontSet="mdi" fontIcon="mdi-dots-vertical"></mat-icon>
            </div>
        </div>
        <div class="attachment-section" *ngIf="showAttachments">
            <div class="pr-8 mr-8" *ngFor="let attachment of attachmentsList; index as index">
                <div class="attach-file relative">
                    <img [src]="attachment.thumbnail_url" *ngIf="attachment.thumbnail_url && checkImageType(attachment.content_type)" class="attachment-img" (error)="addTokenToAttachment(attachment.thumbnail_url)"/>
                    <span class="attachment-name" *ngIf="!checkImageType(attachment.content_type)">{{attachment.filename}} {{attachment.iconType}}</span>
                    <span class="attachment-size" *ngIf="!checkImageType(attachment.content_type)">
                        <ng-container *ngIf="attachment.iconType === 'pdfIcon'"><ng-container *ngTemplateOutlet="pdfIcon" ></ng-container></ng-container>
                        <ng-container *ngIf="attachment.iconType === 'videoIcon'"><ng-container *ngTemplateOutlet="videoIcon" ></ng-container></ng-container>
                        <ng-container *ngIf="attachment.iconType === 'docIcon'"><ng-container *ngTemplateOutlet="docIcon" ></ng-container></ng-container>
                        <ng-container *ngIf="attachment.iconType === 'audioIcon'"><ng-container *ngTemplateOutlet="audioIcon" ></ng-container></ng-container>
                        {{(attachment.filesize / 1000000) | number}} Mb </span>
                </div>
            </div>

            <div class=" pr-8 mr-8" (click)="attachFileForNewTicket.click()"  matTooltip="{{ 'ATTACH_FILE' | translate }}" >
                <div class="attach-file">
                    <mat-icon class="mdi-16px " fontSet="mdi" fontIcon="mdi-plus" class="add-icon"></mat-icon>
                </div>
            </div>
            <input #attachFileForNewTicket style="visibility: hidden;" class="attachFile" (change)="attachFile($event)" multiple="true" type="file"/>
        </div>

    </div>

</ng-template>

<ng-template #footerTemplate>
    <div class="open-in-app-text pointer" role="button" (click)="openInApp()">
        <ng-container *ngTemplateOutlet="openInAppIcon"></ng-container>
        {{'OPEN_IN_APP' |  translate}}
    </div>
    <div class="footer-actions" [ngClass]="{'mobile-footer-german': isMobileScreen && lang === 'de'}">
        <button class="vnc-default vnc-button" (click)="close()">{{ 'CANCEL' | translate }}</button>
        <button class="vnc-primary vnc-button" (click)="createNewTicket()">{{ 'CREATE' | translate }}</button>
    </div>
</ng-template>

<ng-template #chevronDown>
    <svg _ngcontent-eyk-c365="" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18">
        <g _ngcontent-eyk-c365="" fill="none" fill-rule="evenodd">
            <g _ngcontent-eyk-c365="" fill="#000">
                <g _ngcontent-eyk-c365="">
                    <g _ngcontent-eyk-c365="">
                        <g _ngcontent-eyk-c365="">
                            <g _ngcontent-eyk-c365="">
                                <path _ngcontent-eyk-c365="" d="M0 0L3.75 3.75 7.5 0z" transform="translate(-206 -10) translate(64 7) translate(139) translate(3 3) translate(5.25 7.5)"></path>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>
</ng-template>

<ng-template #downLoadIcon>
    <svg width="16px" height="16px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
        <title>Icon/product/download-new</title>
        <g id="Icon/product/download-new" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <path d="M20,15.7142857 C20.5128358,15.7142857 20.9355072,16.1003259 20.9932723,16.5976646 L21,16.7142857 L21,18.0862111 C20.9994237,19.7169267 19.7119789,21.0443605 18.0944856,21.1376211 L17.9134545,21.1428571 L6.08654545,21.1428571 C4.44582791,21.1428571 3.0993365,19.8731997 3.0052513,18.2658002 L3,18.0858577 L3,16.7142857 C3,16.162001 3.44771525,15.7142857 4,15.7142857 C4.51283584,15.7142857 4.93550716,16.1003259 4.99327227,16.5976646 L5,16.7142857 L5,18.0858577 C5,18.6277017 5.42100438,19.0788675 5.96760257,19.1366148 L6.08654545,19.1428571 L17.9131111,19.1428572 C18.4762401,19.1426638 18.9348173,18.7275776 18.9936249,18.2004241 L19,18.0858577 L19,16.7142857 C19,16.162001 19.4477153,15.7142857 20,15.7142857 Z M12,3 C12.5128358,3 12.9355072,3.38604019 12.9932723,3.88337887 L13,4 L13,12.584 L15.2928932,10.2928932 C15.6533772,9.93240926 16.2206082,9.90467972 16.6128994,10.2097046 L16.7071068,10.2928932 C17.0675907,10.6533772 17.0953203,11.2206082 16.7902954,11.6128994 L16.7071068,11.7071068 L12.7071068,15.7071068 C12.3466228,16.0675907 11.7793918,16.0953203 11.3871006,15.7902954 L11.2928932,15.7071068 L7.29289322,11.7071068 C6.90236893,11.3165825 6.90236893,10.6834175 7.29289322,10.2928932 C7.65337718,9.93240926 8.22060824,9.90467972 8.61289944,10.2097046 L8.70710678,10.2928932 L11,12.584 L11,4 C11,3.44771525 11.4477153,3 12,3 Z" id="Shape" fill="#8B96A0"></path>
        </g>
    </svg>
</ng-template>

<ng-template #openInAppIcon>
    <svg width="18px" height="18px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" class="open-link" xmlns:xlink="http://www.w3.org/1999/xlink">
        <g id="Icon/product/new-tab-redirect-new" stroke="none" stroke-width="1" fill-rule="evenodd">
            <path d="M12,3 L12,5 L5,5 L5,19 L19,19 L19,12 L21,12 L21,19 C21,20.1 20.1,21 19,21 L19,21 L5,21 C3.89,21 3,20.1 3,19 L3,19 L3,5 C3,3.9 3.89,3 5,3 L5,3 L12,3 Z M21,3 L21,10 L19,10 L19,6.41 L9.17,16.24 L7.76,14.83 L17.59,5 L14,5 L14,3 L21,3 Z" id="Shape" fill="#8B96A0"></path>
        </g>
    </svg>

</ng-template>

<ng-template #quillToolbar>
    <div class="quill-toolbar-options">
            <div class="quill-toolbar-options-group">
                <button class="ql-bold"></button>
                <button class="ql-italic"></button>
                <button class="ql-underline"></button>
                <button class="ql-strike"></button>
            </div>

            <div class="quill-toolbar-options-group">
                <button class="ql-header" value="1"></button>
                <button class="ql-header" value="2"></button>
            </div>
            <div class="quill-toolbar-options-group">
                <button class="ql-list" value="ordered"></button>
                <button class="ql-list" value="bullet"></button>
            </div>

    </div>

</ng-template>


<ng-template #pdfIcon>
    <svg width="18px" height="18px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
        <g id="Icon/product/file-pdf-box" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g id="ic_audiotrack" transform="translate(3.000000, 3.000000)" fill="#8B96A0" fill-rule="nonzero">
                <g id="Icon-24px">
                    <path d="M15.984375,18 C16.546875,18 17.0234375,17.8046875 17.4140625,17.4140625 C17.8046875,17.0234375 18,16.546875 18,15.984375 L18,15.984375 L18,2.015625 C18,1.453125 17.8046875,0.9765625 17.4140625,0.5859375 C17.0234375,0.1953125 16.546875,0 15.984375,0 L15.984375,0 L2.015625,0 C1.421875,0 0.9375,0.1875 0.5625,0.5625 C0.1875,0.9375 0,1.421875 0,2.015625 L0,2.015625 L0,15.984375 C0,16.546875 0.1875,17.0234375 0.5625,17.4140625 C0.9375,17.8046875 1.421875,18 2.015625,18 L2.015625,18 L15.984375,18 Z M4.4296875,14.9765625 C3.7265625,15.4609375 3.1875,15.453125 2.8125,14.953125 C2.5625,14.203125 2.90625,13.5 3.84375,12.84375 C4.78125,12.1875 5.328125,11.828125 5.484375,11.765625 C6.359375,10.296875 6.9296875,9.15625 7.1953125,8.34375 C7.4609375,7.53125 7.59375,7.109375 7.59375,7.078125 C7.375,6.484375 7.25,5.6875 7.21875,4.6875 C7.1875,3.6875 7.578125,3.125 8.390625,3 C9.171875,3.125 9.4921875,3.765625 9.3515625,4.921875 C9.2109375,6.078125 9.09375,6.734375 9,6.890625 C9.3125,7.828125 9.7890625,8.59375 10.4296875,9.1875 C11.0703125,9.78125 11.421875,10.078125 11.484375,10.078125 C11.953125,9.953125 12.7109375,9.9140625 13.7578125,9.9609375 C14.8046875,10.0078125 15.28125,10.46875 15.1875,11.34375 C14.78125,12.15625 13.984375,12.40625 12.796875,12.09375 C11.609375,11.78125 10.9375,11.5625 10.78125,11.4375 C9.5625,11.5625 8.5625,11.7265625 7.78125,11.9296875 C7,12.1328125 6.59375,12.25 6.5625,12.28125 C5.84375,13.59375 5.1328125,14.4921875 4.4296875,14.9765625 Z M8.390625,5.765625 C8.421875,5.640625 8.4921875,5.28125 8.6015625,4.6875 C8.7109375,4.09375 8.640625,3.734375 8.390625,3.609375 C8.234375,3.671875 8.1875,4.015625 8.25,4.640625 C8.3125,5.265625 8.359375,5.640625 8.390625,5.765625 Z M6.890625,11.484375 C7.515625,11.265625 8.21875,11.0625 9,10.875 L9,10.875 L10.3125,10.59375 C9.59375,9.9375 9.09375,9.3671875 8.8125,8.8828125 C8.53125,8.3984375 8.390625,8.140625 8.390625,8.109375 C8.109375,8.984375 7.796875,9.7578125 7.453125,10.4296875 C7.109375,11.1015625 6.921875,11.453125 6.890625,11.484375 Z M13.4296875,11.203125 C14.0703125,11.390625 14.453125,11.421875 14.578125,11.296875 C14.546875,11.140625 14.25,11.0078125 13.6875,10.8984375 C13.125,10.7890625 12.671875,10.765625 12.328125,10.828125 C12.421875,10.890625 12.7890625,11.015625 13.4296875,11.203125 Z M3.609375,14.671875 C3.734375,14.671875 3.96875,14.5 4.3125,14.15625 C4.65625,13.8125 4.96875,13.328125 5.25,12.703125 C4.75,12.953125 4.328125,13.328125 3.984375,13.828125 C3.640625,14.328125 3.515625,14.609375 3.609375,14.671875 Z" id="symbol"></path>
                </g>
            </g>
        </g>
    </svg>
</ng-template>

<ng-template #videoIcon>
    <svg width="18px" height="18px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
        <g id="Icon/product/frame-video" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g id="Icon-24px" transform="translate(1.000000, 3.000000)" fill="#8B96A0">
                <path d="M20,0 C21.1,0 22,0.9 22,2 L22,2 L22,16 C22,17.1 21.1,18 20,18 L20,18 L2,18 C0.9,18 0,17.1 0,16 L0,16 L0,2 C0,0.9 0.9,0 2,0 L2,0 Z M20,2 L2,2 L2,16 L20,16 L20,2 Z M8.33333333,4.33333333 L15.6666667,9 L8.33333333,13.6666667 L8.33333333,4.33333333 Z" id="Combined-Shape"></path>
            </g>
        </g>
    </svg>
</ng-template>

<ng-template #audioIcon>
    <svg width="18px" height="18px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
        <g id="Icon/product/audiotrack" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g id="Icon-24px" transform="translate(6.000000, 3.000000)" fill="#8B96A0">
                <path d="M6,0 L6,9.28 C5.53,9.11 5.03,9 4.5,9 C2.01,9 0,11.01 0,13.5 C0,15.99 2.01,18 4.5,18 C6.81,18 8.7,16.25 8.95,14 L9,14 L9,3 L13,3 L13,0 L6,0 L6,0 Z" id="Shape"></path>
            </g>
        </g>
    </svg>
</ng-template>

<ng-template #docIcon>
    <svg width="18px" height="18px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
        <title>Icon/product/doc-01-new</title>
        <g id="Icon/product/doc-01-new" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <rect id="Rectangle" stroke="#979797" fill="#D8D8D8" x="8.5" y="11.5" width="7" height="1" rx="0.5"></rect>
            <rect id="Rectangle" stroke="#979797" fill="#D8D8D8" x="8.5" y="15.5" width="7" height="1" rx="0.5"></rect>
            <path d="M13.5857864,2 C13.8510029,2 14.1053568,2.10535684 14.2928932,2.29289322 L19.7071068,7.70710678 C19.8946432,7.89464316 20,8.14899707 20,8.41421356 L20,20 C20,21.1045695 19.1045695,22 18,22 L6,22 C4.8954305,22 4,21.1045695 4,20 L4,4 C4,2.8954305 4.8954305,2 6,2 L13.5857864,2 Z M13.171,4 L6,4 L6,20 L18,20 L18,8.829 L13.171,4 Z M15,15 C15.5522847,15 16,15.4477153 16,16 C16,16.5522847 15.5522847,17 15,17 L9,17 C8.44771525,17 8,16.5522847 8,16 C8,15.4477153 8.44771525,15 9,15 L15,15 Z M15,11 C15.5522847,11 16,11.4477153 16,12 C16,12.5522847 15.5522847,13 15,13 L9,13 C8.44771525,13 8,12.5522847 8,12 C8,11.4477153 8.44771525,11 9,11 L15,11 Z" id="Combined-Shape" fill="#8B96A0"></path>
        </g>
    </svg>
</ng-template>

<ng-template #matSelectTriggerIcon>
    <svg width="18px" height="18px" viewBox="0 0 24 25" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
      <g id="Icon/product/keyboard-arrow-down-new" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
          <path d="M7.25735931,9.79289322 C7.6478836,9.40236893 8.28104858,9.40236893 8.67157288,9.79289322 L12.5,13.6213203 L16.3284271,9.79289322 C16.7189514,9.40236893 17.3521164,9.40236893 17.7426407,9.79289322 C18.133165,10.1834175 18.133165,10.8165825 17.7426407,11.2071068 L12.5,16.4497475 L7.25735931,11.2071068 C6.86683502,10.8165825 6.86683502,10.1834175 7.25735931,9.79289322 Z" id="Path" fill="#8B96A0"></path>
      </g>
    </svg>
</ng-template>

<ng-template #checkIcon>
    <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
      <g id="Icon/product/check" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
          <polygon id="Shape" fill="#337cbd" points="9 16.17 4.83 12 3.41 13.41 9 19 21 7 19.59 5.59"></polygon>
      </g>
    </svg>
</ng-template>